import styled, { css } from 'styled-components';
var ErrorContainer = styled.div.withConfig({
  displayName: "ErrorContainer",
  componentId: "sc-1nw03ru-0"
})(["margin-top:0.125rem;", ""], function (_ref) {
  var centered = _ref.centered;
  return centered && css(["text-align:center;"]);
});
export default ErrorContainer;